import { z } from "zod";
import { AdvisorId, ClientId, DateSchema } from "../Types";
import { RelationshipNoteId } from "./types";
// Individual note schema
export const RelationshipNoteListItemSchema = z.object({
    noteId: RelationshipNoteId,
    clientId: ClientId,
    clientName: z.string(),
    title: z.string(),
    createdAt: DateSchema,
    createdById: AdvisorId,
    createdByName: z.string(),
    updatedAt: DateSchema,
    updatedById: AdvisorId,
    updatedByName: z.string(),
    wordCount: z.number(),
    characterCount: z.number(),
});
// Pagination schema
export const PaginationSchema = z.object({
    page: z.number(),
    limit: z.number(),
    totalPages: z.number(),
    totalCount: z.number(),
    currentCount: z.number(),
    hasNext: z.boolean(),
    hasPrevious: z.boolean(),
});
// Filters applied schema
export const FiltersAppliedSchema = z.object({
    dateFrom: DateSchema.optional(),
    dateTo: DateSchema.optional(),
    search: z.string().optional(),
});
// -- Pagination Schemas --
export const pageQueryString = z
    .number()
    .int()
    .min(1)
    .default(1)
    .describe("The page number, default is 1");
export const limitQueryString = z
    .number()
    .int()
    .min(1)
    .max(100)
    .default(10)
    .describe("The page limit, default is 20");
export const SortBySchema = z
    .enum(["createTime", "modifyTime", "title"])
    .default("createTime");
export const SortOrderSchema = z.enum(["asc", "desc"]).default("desc");
// -- Get Relationship Notes Schemas --
export const GetRelationshipNotesListResponseBodySchema = z.object({
    data: z.array(RelationshipNoteListItemSchema),
    pagination: PaginationSchema,
    filtersApplied: FiltersAppliedSchema,
});
export const GetRelationshipNotesListQuerySchema = z.object({
    page: pageQueryString.optional(),
    limit: limitQueryString.optional(),
    sortBy: SortBySchema.optional(),
    sortOrder: SortOrderSchema.optional(),
    dateFrom: z.date().optional(),
    dateTo: z.date().optional(),
    search: z.string().optional(),
    clientId: ClientId,
    advisorId: AdvisorId,
});
//# sourceMappingURL=schemas.js.map